let Test = require('@/mixins/Forms/2019/NRCA_LTO_02_A')

module.exports = {

    mixins: [Test],

    data() {
        return {
            form: new Form({
                construction_inspection: {
                    name: `Construction Inspection (NA7.8.7)`,
                    questions: {
                        question_1: {
                            id: `a`,
                            question: `The automatic scheduling control is installed. (NA7.8.7(a))`,
                            answer: false
                        },
                        question_2: {
                            id: `b`,
                            question: `The automatic scheduling control is programmed with ON and OFF schedules that match the schedules in the construction documents. <b>OR</b><br>If the schedule is unknown, the programmed schedule matches the default schedule where the OFF schedule is from 12:00 A.M. to 6:00 A.M. and the ON schedule is all other night time hours, 7 days per week. (NA7.8.7(b))`,
                            answer: false
                        },
                        question_3: {
                            id: `c`,
                            question: `Demonstrate and document the lighting control programming including ON and OFF schedules for weekdays, weekends, and holidays (if applicable). (NA7.8.7(c))`,
                            answer: false
                        },
                        question_4: {
                            id: `d`,
                            question: `The correct time and date are properly set in the control. (NA7.8.7(d))`,
                            answer: false
                        },
                        question_5: {
                            id: `e`,
                            question: `The motion sensor has been located to minimize false signals. (NA7.8.7(a))`,
                            answer: false
                        },
                        question_6: {
                            id: `f`,
                            question: `The motion sensor is not triggered by motion outside of controlled area. (NA7.8.7(b))`,
                            answer: false
                        },
                        question_7: {
                            id: `g`,
                            question: `The desired motion sensor coverage is not blocked by obstructions that could adversely affect performance. (NA7.8.7(c))`,
                            answer: false
                        },
                    },
                    result: false,
                },
                functional_test: {
                    name: `Functional Testing (NA7.8.8)`,
                    steps: {
                        step_1: {
                            name: `Step 1: Daytime simulation`,
                            questions: {
                                question_1: {
                                    id: `a`,
                                    question: `During daytime simulation, all controlled outdoor lighting is turned off. (NA7.8.8(a), Section 130.2(c)1)`,
                                    answer: false
                                },
                            }
                        },
                        step_2: {
                            name: `Step 2: Nighttime simulation`,
                            questions: {
                                question_1: {
                                    id: `b`,
                                    question: `During nighttime simulation, all controlled outdoor lighting is turned on in accordance with the programmed schedule. (NA7.8.8(b), §130.2(c)2B)`,
                                    answer: false
                                },
                                question_2: {
                                    id: `c`,
                                    question: `During nighttime simulation, the power of controlled lighting is turned off or reduced by at least 50% in accordance with the programmed schedule. (NA7.8.8(c), §130.2(c)2A, §130.2(c)2B)`,
                                    answer: false
                                },
                            }
                        },
                        step_3: {
                            name: `Step 3: Simulate motion in the controlled area. (NA7.8.8(b))`,
                            questions: {
                                question_1: {
                                    id: `d`,
                                    question: `The status indicator operates correctly. (NA7.8.8(b)i)`,
                                    answer: false
                                },
                                question_2: {
                                    id: `e`,
                                    question: `The controlled lighting turns on immediately upon entry into the controlled area. (NA7.8.8(b)ii)`,
                                    answer: false
                                },
                                question_3: {
                                    id: `f`,
                                    question: `The signal sensitivity is adequate to achieve desired control. (NA7.8.8(b)iii)`,
                                    answer: false
                                },
                            }
                        },
                        step_4: {
                            name: `Step 4: During simulation of the normally occupied schedule, simulate no occupancy in the controlled area. (NA7.8.8(c))`,
                            questions: {
                                question_1: {
                                    id: `g`,
                                    question: `The power of controlled lighting is reduced by at least 50% within 15 minutes from the start of an unoccupied condition. Fraction of light output reduction is an acceptable proxy for reduction in lighting power. (NA7.8.8(c)i, Section 130.2(c)3A, Section 130.2(c)3B)`,
                                    answer: false
                                },
                                question_2: {
                                    id: `h`,
                                    question: `The sensor does not trigger a false "on" from movement outside of the controlled area. (NA7.8.2, Step 2(b))`,
                                    answer: false
                                },
                                question_3: {
                                    id: `i`,
                                    question: `The signal sensitivity is adequate to achieve the desired control. (NA7.8.8(c)ii)`,
                                    answer: false
                                },
                            }
                        },
                        step_5: {
                            name: `Step 5: During simulation of the normally unoccupied schedule, simulate no occupancy in the controlled area. (NA7.8.8(d))`,
                            questions: {
                                question_1: {
                                    id: `j`,
                                    question: `The power of controlled lighting is reduced by at least 50% within 15 minutes from the start of an unoccupied condition. Fraction of light output reduction is an acceptable proxy for reduction in lighting power. (NA7.8.8(d)i, Section 130.2(c)3A, Section 130.2(c)3B)`,
                                    answer: false
                                },
                                question_2: {
                                    id: `k`,
                                    question: `The sensor does not trigger a false "on" from movement outside of the controlled area. (NA7.8.2, Step 2(b))`,
                                    answer: false
                                },
                                question_3: {
                                    id: `l`,
                                    question: `The signal sensitivity is adequate to achieve the desired control. (NA7.8.8(d)ii)`,
                                    answer: false
                                },
                            }
                        }
                    },
                    result: false,
                },
                comments: '',
                testResult: false,
            })
        }
    },

}
